import { HOMEPAGE_PRIMARY_HEADING } from '@chegg-wt/core-wa/constants/paraphraser'
import { HeadingsContainer, PrimaryHeading } from './styled'

const WAHomepageHeadings = () => {
  return (
    <HeadingsContainer>
      <PrimaryHeading>{HOMEPAGE_PRIMARY_HEADING}</PrimaryHeading>
    </HeadingsContainer>
  )
}

export default WAHomepageHeadings
